// Values mirror ethics-quotient's `Survey::SOURCE_*` / `Survey::PROVIDER_*` stored
// strings; changing one would stop skip rules on those surveys resolving.
/** `surveys.source`: where an assessment was authored. */
export var SurveySource;
(function (SurveySource) {
    SurveySource["Platform"] = "platform";
    SurveySource["Imported"] = "imported";
})(SurveySource || (SurveySource = {}));
/** `surveys.provider`: the tool an imported assessment came from. */
export var SurveyProvider;
(function (SurveyProvider) {
    SurveyProvider["Alchemer"] = "alchemer";
    SurveyProvider["Momentive"] = "momentive";
})(SurveyProvider || (SurveyProvider = {}));
//# sourceMappingURL=survey.js.map